import React, { useEffect, useState, useCallback } from "react";
import { Api_Token } from "../../util/Api"; // Replace with your API token logic
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  IconButton,
  Grid,
  TextField,
  MenuItem,
  CardContent,
  Pagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ModelCheck from "../../components/popup/ModelCheck";
import CustomAlert from "../../components/Alert/AlertCustomer";
import DeleteConfirmation from "../../components/popup/deleteConfirmation";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";

import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import Datepicker from "react-tailwindcss-datepicker";
import DownloadIcon from "@mui/icons-material/Download";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import LabelTypography from "../../components/Typography/LabelTypography";
const statutOptions = ["en attente", "accepté", "rejeté"];

function CheckManagementPage() {
  return <Indexdasboard Children={<CheckList />} />;
}

const CheckList = () => {
  const [checks, setChecks] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [AlertEtat, setAlertEtat] = useState("initial");
  const [AlertMessage, setAlertMessage] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [checkToDelete, setCheckToDelete] = useState(null);
  const [FilterByStatus, setFilterByStatus] = useState("all");
  const [DateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [formData, setFormData] = useState({
    nom: "",
    numero_cheque: "",
    banque: "",
    montant: "",
    date_emission: "",
    date_encaissement: null,
    statut_cheque: "en attente",
  });
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const fetchChecks = useCallback(
    async (currentPage, rowsPerPage, FilterByStatus, DateRange) => {
      try {
        const filterStatusParam =
          FilterByStatus || FilterByStatus !== "all status"
            ? `&filterStatus=${FilterByStatus}`
            : "";
        const formattedStartDate = DateRange.startDate
          ? new Date(DateRange.startDate).toISOString().split("T")[0]
          : null;
        const formattedEndDate = DateRange.endDate
          ? new Date(DateRange.endDate).toISOString().split("T")[0]
          : null;
        const FilterByDate =
          formattedEndDate && formattedStartDate
            ? `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
            : "";
        const response = await Api_Token.get(
          `/Check/getChequePaginate?page=${
            currentPage + 1
          }&perPage=${rowsPerPage}${filterStatusParam}${FilterByDate}`
        );
        setChecks(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching checks:", error);
      }
    },
    []
  );

  useEffect(() => {
    fetchChecks(page, rowsPerPage, FilterByStatus, DateRange);
  }, [fetchChecks, page, rowsPerPage, FilterByStatus, DateRange]);

  const handleDeleteCheck = async () => {
    try {
      await Api_Token.delete(`/cheques/${checkToDelete.id}`);
      setAlertEtat("success");
      setAlertMessage(t("Check deleted successfully!"));
      fetchChecks(page, rowsPerPage);
      handleCloseDeleteDialog();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error deleting check: ") + error.message);
    }
  };

  const handleSubmit = async () => {
    try {
      if (formData.id) {
        await Api_Token.post(`/Check/updateCheque/${formData.id}`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Check updated successfully!"));
      } else {
        await Api_Token.post(`/cheques`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Check created successfully!"));
      }
      fetchChecks(page, rowsPerPage);
      handleCloseModal();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error submitting form: ") + error.message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (
    check = {
      nom: "",
      numero_cheque: "",
      banque: "",
      montant: "",
      date_emission: "",
      date_encaissement: null,
      statut_cheque: "en attente",
    }
  ) => {
    setFormData(check);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setError(null);
  };
  /*
  const handleOpenDeleteDialog = (check) => {
    setCheckToDelete(check);
    setOpenDeleteDialog(true);
  };
*/
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setCheckToDelete(null);
  };

  const handleDownload = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = imageUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Box>
      <TitreGraphik> {t("Gestion des Chèques")}</TitreGraphik>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Card sx={{ padding: "2%", marginTop: "2%", minHeight: "600px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    sx={{ width: "50%" }}
                    select
                    placeholder="filter by status"
                    //  label={t("Statut")}
                    name="statut_cheque"
                    value={FilterByStatus}
                    onChange={(e) => {
                      setFilterByStatus(e.target.value);
                    }}
                    margin="normal"
                  >
                    <MenuItem value={"all"}>all status</MenuItem>
                    {statutOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      border: "1px  #000",
                      borderRadius: "8px",
                    }}
                  >
                    <Datepicker
                      inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                      primaryColor={"blue"}
                      value={DateRange}
                      onChange={(newDateRange) => {
                        setDateRange(newDateRange);
                        setPage(0);
                      }}
                      showShortcuts={true}
                      showFooter={true}
                      popoverDirection="down"
                      placeholder="  filter by date"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {" "}
              <TableContainer sx={{ marginTop: "20px" }}>
                <Table sx={{ minWidth: 650 }} aria-label="checks table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {t("ID")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Nom")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Numéro Chèque")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Banque")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Montant")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Date Emission")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Date Encaissement")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Statut")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {"Actions"}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {checks?.map((check) => (
                      <StyledTableRow key={check.id}>
                        <StyledTableCell align="center">
                          {check.id}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.nom}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.numero_cheque}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.banque}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <NumericFormatEnv Number={check.montant} />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.date_emission}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.date_encaissement || "N/A"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {check.statut_cheque}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <IconButton
                            onClick={() => handleDownload(check.image)}
                          >
                            <DownloadIcon />
                          </IconButton>
                          <IconButton onClick={() => handleOpenModal(check)}>
                            <EditIcon />
                          </IconButton>
                          {/*  <IconButton
                      color="error"
                      onClick={() => handleOpenDeleteDialog(check)}
                    >
                      <DeleteIcon />
                    </IconButton> */}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Grid>
        </Card>
      </Box>
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Grid container spacing={2} sx={{ marginTop: "20px", width: "100%" }}>
          <Grid item xs={12}>
            <Card>
              <TextField
                //  sx={{ width: "50%" }}
                fullWidth
                select
                placeholder="filter by status"
                //  label={t("Statut")}
                name="statut_cheque"
                value={FilterByStatus}
                onChange={(e) => {
                  setFilterByStatus(e.target.value);
                }}
                //  margin="normal"
              >
                <MenuItem value={"all"}>all status</MenuItem>
                {statutOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <Box
                sx={{
                  border: "1px  #000",
                  borderRadius: "8px",
                }}
              >
                <Datepicker
                  inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                  primaryColor={"blue"}
                  value={DateRange}
                  onChange={(newDateRange) => {
                    setDateRange(newDateRange);
                    setPage(0);
                  }}
                  showShortcuts={true}
                  showFooter={true}
                  popoverDirection="down"
                  placeholder="  filter by date"
                />
              </Box>
            </Card>
          </Grid>
          {checks.map((check) => (
            <Grid item xs={12} sm={6} md={4} key={check.id}>
              <Card sx={{ padding: 2 }}>
                <CardContent>
                  <LabelTypography variant="h6" align="center">
                    #{check.id}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Nom")}:</strong> {check.nom}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Numéro Chèque")}:</strong> {check.numero_cheque}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Banque")}:</strong> {check.banque}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Montant")}:</strong>{" "}
                    <NumericFormatEnv Number={check.montant} />
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Date Emission")}:</strong> {check.date_emission}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Date Encaissement")}:</strong>{" "}
                    {check.date_encaissement || "N/A"}
                  </LabelTypography>
                  <LabelTypography variant="body1">
                    <strong>{t("Statut")}:</strong> {check.statut_cheque}
                  </LabelTypography>
                  <Grid
                    container
                    justifyContent="center"
                    spacing={1}
                    sx={{ marginTop: 2 }}
                  >
                    <Grid item>
                      <IconButton onClick={() => handleDownload(check.image)}>
                        <DownloadIcon />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <IconButton onClick={() => handleOpenModal(check)}>
                        <EditIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Box
              sx={{
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Pagination
                count={Math.ceil(totalCount / rowsPerPage)}
                onChange={(event, newPage) => {
                  setPage(newPage - 1); // Adjust for 0-based indexing
                }}
                variant="outlined"
                color="primary"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <ModelCheck
        open={openModal}
        onClose={handleCloseModal}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        error={error}
      />
      <DeleteConfirmation
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        message={t(`Êtes-vous sûr de vouloir supprimer ce chèque ?`)}
        confirme={handleDeleteCheck}
      />
      <CustomAlert
        open={AlertEtat !== "initial"}
        onClose={() => {
          setAlertEtat("initial");
        }}
        etat={AlertEtat}
        message={AlertMessage}
      />
    </Box>
  );
};

export default CheckManagementPage;
